<template>
  <div>
    <div class="qrcode">
      <qrcode :value="'https://anm22.it/?tkice=' + projectId" :options="{ width: 200 }" tag="img"></qrcode>
    </div>
    <div class="qrcode-info">
      <div class="info-text">{{ $anm22.strLang(lang, 'QR Code to apply inside the suit.', 'QR Code da applicare all\'interno della tuta.') }}</div>
      <img src="@/assets/vircos-label-sample.png" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String]
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
    }),
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.qrcode {
  display: block;
  margin: 0 auto;
  padding: 10px;
  width: 220px;
  height: 220px;
}
.qrcode-info {
  border-top: 1px solid #ccc;
  padding-top: 10px;

  .info-text {
    font-size: 14px;
    text-align: center;
    color: #777;
    padding: 10px 0;
  }

  img {
    width:60%;
    display: block;
    margin: 0 auto;
  }
}
</style>